<template>
<div class="page-container-wrapper h-100">
  <b-modal size="lg"
    id="welcomeDialog"
    centered 
    :title="$t('message.Guideline.yourNextSteps')"
    ref="welcomeDialogRef"
    :hide-footer="true"
    v-model="welcomeDialog"
    @hidden="welcomeDialogOff"
    :data-trigger-dialog="showWelcomeDialog">

    <div v-if="isCommitteeUser">
      <div class="welcome-section-box">
        <h5 class="welcome-section-title">{{ $t('message.Guideline.myCommittee') }}</h5>
        <b-button variant="outline-secondary" @click="onWelcomeFilter([0])">{{ $t('message.Guideline.showSavedDrafts') }}</b-button>
        <b-button variant="outline-secondary" class="ml-2" 
          @click="onWelcomeFilter([
              guidelinePhases.formalCheckApproval,
              guidelinePhases.preApproved,
              guidelinePhases.uploadedForGpcReview,
              guidelinePhases.uploadGpcReviewed,
              guidelinePhases.uploadedForReview,
              guidelinePhases.parallelReview,
              guidelinePhases.parallelReviewed,
              guidelinePhases.uploadReviewed,
              guidelinePhases.reviewedByNationalDelegates,
              guidelinePhases.reviewByNationalDelegatesEnd,
              guidelinePhases.boardApprovalApproved,
              guidelinePhases.gpcFinalHold,
              guidelinePhases.boardApprovalOnHold
              ])"
          >{{ $t('message.Guideline.showMyTodos') }}</b-button>
      </div>

      <div class="welcome-section-box">
        <h5 class="welcome-section-title">{{ $t('message.Guideline.otherCommittees') }}</h5>
        <b-button variant="outline-secondary" @click="onWelcomeFilter([50])">{{ $t('message.Guideline.underCommitteeReview') }}</b-button>
      </div>

      <div class="welcome-section-box">
        <h5 class="welcome-section-title">{{ $t('message.Guideline.others') }}</h5>
        <b-button variant="outline-secondary" @click="onWelcomeFilter()">{{ $t('message.Guideline.showAll') }}</b-button>
        <b-button v-if="allowAdd()" class="ml-2" variant="outline-primary" @click="welcomeDialogOff();$router.push('/guidelines/pre-approve-draft')">{{ $t('message.Guideline.add') }}</b-button>
      </div>
    </div>

    <div v-if="isGpc">
      <div class="welcome-section-box">
        <b-button variant="outline-secondary" @click="onWelcomeFilter([10, 42, 102])">{{ $t('message.Guideline.showMyTodos') }}</b-button>
        <b-button variant="outline-secondary" class="ml-2" @click="onWelcomeFilter()">{{ $t('message.Guideline.showAll') }}</b-button>
      </div>
    </div>

    <div v-if="isIgo">
      <div class="welcome-section-box">
        <b-button variant="outline-secondary" @click="onWelcomeFilter([110])">{{ $t('message.Guideline.showMyTodos') }}</b-button>
        <b-button variant="outline-secondary" class="ml-2" @click="onWelcomeFilter()">{{ $t('message.Guideline.showAll') }}</b-button>
      </div>
    </div>

    <div v-if="isNationalDelegate">
      <div class="welcome-section-box">
        <b-button variant="outline-secondary" @click="onWelcomeFilter([52, 80])">{{ $t('message.Guideline.showMyTodos') }}</b-button>
        <b-button variant="outline-secondary" class="ml-2" @click="onWelcomeFilter([60, 70])">Show upcoming projects</b-button>
      </div>
    </div>
  </b-modal>

  <loader v-if="dataLoading"/>
  <template v-else>
    <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}
          <template v-if="phase === guidelinePhases.rejected">[{{ $t('message.LeftBar.rejectedGuidelines') }}]</template>
          <template v-else-if="phase === guidelinePhases.preApproved">[{{ $t('message.LeftBar.preApprovedGuidelines') }}]</template>
          <template v-else-if="phase === guidelinePhases.formalCheckApproval">[{{ $t('message.LeftBar.additionalWorkNeed') }}]</template>
        </h2>
    </div>

    <div class="guidelines-list-content">

      <div class="page-container full-size-container flex-grow-1 guidelines-list-table shadow-on-box" id="page-container">
        <b-alert v-show="dataError" class="mt-4" show variant="danger">{{ $t('message.connectionError') }}</b-alert>

        <div class="page-container-toolbar justify-content-between">
          <b-button class="mr-2" v-if="allowAdd()" variant="outline-primary" @click="$router.push('/guidelines/pre-approve-draft')">{{ $t('message.Guideline.add') }}</b-button>

          <div class="col-sm-8">
            <b-row>
              <b-col sm="10">
                <b-form-input type="text" v-model="query" placeholder="search" @keyup.enter.native="getData" ></b-form-input>
              </b-col>

              <b-col sm="1">
                <b-button class="btn btn-sm btn-white" @click="getData">
                  <i class="i-con i-con-search"><i></i></i>
                </b-button>
              </b-col>

              <b-col sm="1">
                <b-button v-if="query.length>0" class="btn btn-sm btn-danger" @click="clearQuery">
                  <i class="i-con i-con-close"><i></i></i>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        
        <div v-if="dataEmpty" class="padding">
          <b-alert variant="primary" show>{{ $t('message.Guideline.empty') }}</b-alert>
        </div>
        <div v-else class="p20">
          <template>
            <b-table hover :items="guidelines.data" :fields="defaultFields" :sort-compare="this.sortTable">
              <template slot="table-colgroup">
                <col width="150px">
                <col>
                <col>
                <col>
                <col width="150px">
                <col>
                <col>
              </template>

              <template slot="phase" slot-scope="data">
                <span class="badge text-white phase-width" :class="'lh-12 text-left phase'+data.item.phase" v-html="$t('message.Guideline.phase' + data.item.phase)"></span>
              </template>

              <template slot="deadline" slot-scope="data">
                <template v-if="isSuperUser && data.item.id != null">
                  <span v-if="deadline_edit_id !== data.item.id" class="nav-text">
                    <span>{{ data.item.deadline }}</span>
                    <a @click.prevent="editDeadline(data.item)" href="#" class="i-con-h-a">
                      <span class="nav-icon d-inline-flex">
                        <i class="i-con i-con-edit"></i>
                      </span>
                    </a>
                  </span>
                  <template v-else>
                    <datepicker
                      v-model="deadline"
                      format="dd-MM-yyyy"
                      input-class="form-control">
                    </datepicker>

                    <input
                      type="hidden"
                      v-model="deadline"
                      v-validate="'required'"
                      data-vv-name="deadline"
                      data-vv-scope="deadline"
                    />

                    <a class="i-con-h-a" @click.prevent="cancelEditDeadline">
                      <i class="mr-2 i-con i-con-close"></i>
                    </a>

                    <a class="i-con-h-a" @click.prevent="commitEditDeadline(data.item)">
                      <i class="mr-2 i-con i-con-ok"><i class="i-con-border"></i></i>
                    </a>
                  </template>
                </template>
                <template v-else>
                  {{ data.item.deadline }}
                </template>
              </template>

              <template slot="my_role" slot-scope="row">
                <span class="mr-1" v-if="imSubmitter(row.item)"><span class="badge badge-info">{{ $t('message.Guideline.submitter') }}</span> </span>

                <span class="mr-1" v-if="imReviewer(row.item)"><span class="badge badge-success">{{ $t('message.Guideline.RoleAcceptance.roles.2' )}}</span></span>
              </template>

              <template slot="row-details" slot-scope="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.uniqueId') }}</b></b-col>
                    <b-col>{{ row.item.unique_id }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.createdAt') }}</b></b-col>
                    <b-col>{{ row.item.created_at }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.updatedAt') }}</b></b-col>
                    <b-col>{{ row.item.updated_at }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.deadline') }}</b></b-col>
                    <b-col>{{ row.item.deadline }}</b-col>
                  </b-row>

                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.submitter_name') }}</b></b-col>
                    <b-col>{{ row.item.submitter_name }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.my_role') }}</b></b-col>
                    <b-col>
                      <p v-if="imSubmitter(row.item)">{{ $t('message.Guideline.submitter') }}</p>

                      <p v-if="imReviewer(row.item)">{{ $t('message.Guideline.RoleAcceptance.roles.2') }}</p>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.destinationLabel') }}</b></b-col>
                    <b-col>{{ $t('message.Guideline.destinationsOfManuscript.' + row.item.publication) }}</b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col sm="3" class="text-sm-right"><b>{{ $t('message.Guideline.type') }}</b></b-col>
                    <b-col>{{ $t('message.Guideline.typesOfManuscript.' + row.item.type) }}</b-col>
                  </b-row>
                </b-card>
              </template>

              <template slot="showDetails" slot-scope="row">
                <b-form-checkbox 
                  @click.native.stop 
                  @change="row.toggleDetails"
                  v-model="row.detailsShowing"></b-form-checkbox>
              </template>
              <template slot="actions" slot-scope="data">
                <div class="action-button-container" v-if="data.item.id!=null">
                  <button v-if="allowEdit(data.item)" @click="$router.push('/guidelines/' + data.item.id + '/edit')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.edit')">
                    <i class="i-con i-con-edit text-muted"><i></i></i>
                    <font-awesome-icon v-if="showAdditionalWorkNeedNotification(data.item)" icon="exclamation-circle" class="notification"/>
                  </button>

                  <button @click="$router.push('/guidelines/' + data.item.id + '/view')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.view')">

                    <i v-if="showFileIcon(data.item)" class="i-con i-con-file text-muted"><i></i></i>
                    <i v-else class="i-con i-con-eye text-muted"><i></i></i>

                    <font-awesome-icon v-if="showViewNotification(data.item)" icon="exclamation-circle" class="notification"/>
                  </button>

                  <template v-if="allowAdminUpload(data.item)">
                    <button @click="uploadForUser(data.item, data.item.submitter_id, data.item.upload_id, true)" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.uploadForUser')"><i class="i-con i-con-upload text-muted"><i></i></i></button>
                  </template>

                  <button v-if="showEditOnHold(data.item)"  @click="$router.push('/guidelines/' + data.item.id + '/on-hold')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.edit')">
                    <i class="i-con i-con-edit text-muted"></i>
                  </button>

                  <template v-if="forwardToCommittee(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/nd-review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.forwardToCommittee')"><i class="i-con i-con-arrow-right text-muted"><i></i></i>

                      <font-awesome-icon v-if="showForwardToCommitteeNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="forwardToNatDel(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/nd-review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.forwardToNatDel')"><i class="i-con i-con-arrow-right text-muted"><i></i></i>

                      <font-awesome-icon v-if="showForwardToNDNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowParallelDecision(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/nd-review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.parallelReviewDecision')"><i class="i-con i-con-arrow-right text-muted"><i></i></i>

                      <font-awesome-icon v-if="showParallelDecisionNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowUpload(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/upload')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.uploadFile')"><i class="i-con i-con-upload text-muted"><i></i></i>
                      
                      <font-awesome-icon v-if="showUploadNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowGpcReview(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/gpc-review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="getGpcReviewLabel(data.item)"><i class="i-con i-con-refresh text-muted"><i></i></i>

                      <font-awesome-icon v-if="showGpcReviewNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowFinalOnHoldUpload(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/on-hold')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.uploadGpcOnHoldFile')"><i class="i-con i-con-upload text-muted"><i></i></i>

                      <font-awesome-icon v-if="showFinalHoldNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowReview(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="getReviewLabel(data.item)"><i class="i-con i-con-refresh text-muted"><i></i></i>

                      <font-awesome-icon v-if="showReviewNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowNdReview(data.item)">
                      <button @click="$router.push('/guidelines/' + data.item.id + '/nd-review')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.showNdReview')"><i class="i-con i-con-archive text-muted"><i></i></i>
                        <font-awesome-icon v-if="showNDReviewNotification(data.item)" icon="exclamation-circle" class="notification"/>
                      </button>
                  </template>

                  <template v-if="startBoardProcess(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/gpc-final-approval-process')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.startBoardProcess')"><i class="i-con i-con-globe text-muted"><i></i></i>

                      <font-awesome-icon v-if="showStartBoardProcessNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>

                  <template v-if="allowFinalPublication(data.item)">
                    <button @click="$router.push('/guidelines/' + data.item.id + '/final-publication')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.finalPublication')"><i class="i-con i-con-clear-day text-muted"><i></i></i>
                      <font-awesome-icon v-if="showFinalPublicationNotification(data.item)" icon="exclamation-circle" class="notification"/>
                    </button>
                  </template>


                  <template v-if="allowUploadCorrectedFiles(data.item)">
                      <button @click="$router.push('/guidelines/' + data.item.id + '/upload')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.uploadCorrectedFiles')"><i class="i-con i-con-upload text-muted"><i></i></i></button>
                  </template>

                  <template v-if="allowCoiManagment(data.item)">
                      <button @click="$router.push('/guidelines/' + data.item.id + '/coi-managment')" class="btn btn-sm btn-white i-con-h-a mr-2 position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.Guideline.coiManagment')"><i class="i-con i-con-bookmark text-muted"><i></i></i>

                        <font-awesome-icon v-if="showDoiNotification(data.item)" icon="exclamation-circle" class="notification"/>
                      </button>
                  </template>

                  <template v-if="allowDelete(data.item)">
                      <button @click="deleteRowConfirm(data.item)" class="btn btn-sm btn-white i-con-h-a position-relative" data-toggle="tooltip" v-b-tooltip.hover :title="$t('message.delete')"><i class="i-con i-con-trash text-muted"><i></i></i></button>
                  </template>
                </div>
                <template v-else>
                  {{ $t('message.deleted') }}
                </template>
              </template>
            </b-table>
          </template>

          <admin-upload :guideline="adminUpload.guideline" :userId="adminUpload.userId" :uploadId="adminUpload.uploadId" :show="adminUpload.show" :isGuidelineSubmitter="false" :isReviewUpload="adminUpload.isReviewUpload" @close="adminCloseUpload($event)"></admin-upload>

          <template v-if="guidelines.meta.last_page > 1">
            <b-pagination-nav size="md" :link-gen="linkGen" :use-router=true :total-rows="guidelines.meta.total"
                              :number-of-pages="guidelines.meta.last_page" v-model="guidelines.meta.current_page"
                              :per-page="10"></b-pagination-nav>
          </template>
        </div>
      </div>

      <div v-if="isCommitteeUser || isSuperUser || isGpc || isIgo" class="guidelines-list-filter shadow-on-box">
        <b-form-group>
          <b-form-checkbox-group name="phases" v-model="phaseFilter" stacked>
            <b-form-checkbox v-for="(obj, key) in filterOptions" :value="obj.value" class="filter-checkbox" v-bind:key="key">
              <span class="badge text-white phase-width" :class="'lh-12 text-left phase'+obj.value" v-html="obj.label"></span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <b-row class="mb-2">
          <b-col>
            <b-button variant="success" size="sm" class="ml-2" @click="filterSelectAll(true)">{{ $t('message.selectAll') }}</b-button>
            <b-button variant="warning" size="sm" class="ml-2" @click="filterSelectAll()">{{ $t('message.unselectAll') }}</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-button variant="outline-secondary" size="sm" class="ml-2" @click="getFiltered">{{ $t('message.Guideline.filterGuidelines') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
</div>
</template>

<script>
import { GUIDELINES_REQUEST, GUIDELINE_DELETE, GUIDELINE_UPDATE_DEADLINE, GUIDELINE_SET_QUERY} from '@/store/actions/guidelines';
import {SHOW_WELCOME_DIALOG} from '@/store/actions/welcome_dialog'

import { mapGetters } from 'vuex'

import { GuidelinePhases } from '@/lib/guideline.js';

import AdminUpload from '@/components/Guideline/GuidelineReview/AdminUpload'

export default {
  name: 'guidelines-list',
  components: {
    AdminUpload
  },
  props: ['phase'],
  data () {
    return {
      guidelines: {
        data: [],
        meta: {
          current_page: 1
        },
        links: {}
      },

      guidelinePhases: GuidelinePhases,

      adminUpload: {
        guideline: null,
        userId: null,
        uploadId: null,
        isReviewUpload: false,
        show: false
      },

      phaseFilter: [],

      deadline: null,
      deadline_edit_id: null,

      welcomeDialog: null,
    }
  },
  computed: {
    ...mapGetters([
      'getWelcomeDialog'
    ]),

    showWelcomeDialog() {
      this.welcomeDialog = this.getWelcomeDialog && (this.isGpc || this.isIgo || this.isCommitteeUser);
      return this.welcomeDialog;
    },

    selectAllStatus: {
      get: function () {
        return this.phaseFilter.length === this.filterOptions.length;
      }
    },

    query: {
      get: function () {
        return this.$store.state.guidelines.guideline_query;
      },
      set: function (newValue) {
        this.$store.commit(GUIDELINE_SET_QUERY, newValue);
      }
    },

    filterOptions() {
      return [
        { value: this.guidelinePhases.draft, label: this.$t('message.Guideline.phase0') },
        { value: this.guidelinePhases.submitted, label: this.$t('message.Guideline.phase10') },
        { value: this.guidelinePhases.formalCheckApproval, label: this.$t('message.Guideline.phase30') },
        { value: this.guidelinePhases.preApproved, label: this.$t('message.Guideline.phase40') },
        { value: this.guidelinePhases.uploadedForGpcReview, label: this.$t('message.Guideline.phase42') },
        { value: this.guidelinePhases.uploadGpcReviewed, label: this.$t('message.Guideline.phase44') },
        { value: this.guidelinePhases.uploadGpcReviewedEnd, label: this.$t('message.Guideline.phase46') },
        { value: this.guidelinePhases.uploadedForReview, label: this.$t('message.Guideline.phase50') },
        { value: this.guidelinePhases.parallelReview, label: this.$t('message.Guideline.phase52') },
        { value: this.guidelinePhases.parallelReviewed, label: this.$t('message.Guideline.phase54') },
        { value: this.guidelinePhases.parallelReviewEnd, label: this.$t('message.Guideline.phase56') },
        { value: this.guidelinePhases.uploadReviewed, label: this.$t('message.Guideline.phase60') },
        { value: this.guidelinePhases.uploadReviewedEnd, label: this.$t('message.Guideline.phase70') },
        { value: this.guidelinePhases.reviewByNationalDelegates, label: this.$t('message.Guideline.phase80') },
        { value: this.guidelinePhases.reviewedByNationalDelegates, label: this.$t('message.Guideline.phase90') },
        { value: this.guidelinePhases.reviewByNationalDelegatesEnd, label: this.$t('message.Guideline.phase100') },
        { value: this.guidelinePhases.gpcFinalApproval, label: this.$t('message.Guideline.phase102') },
        { value: this.guidelinePhases.gpcFinalHold, label: this.$t('message.Guideline.phase104') },
        { value: this.guidelinePhases.boardApproval, label: this.$t('message.Guideline.phase110') },
        { value: this.guidelinePhases.boardApprovalApproved, label: this.$t('message.Guideline.phase120') },
        { value: this.guidelinePhases.boardApprovalOnHold, label: this.$t('message.Guideline.phase130') },
        { value: this.guidelinePhases.finalPublish, label: this.$t('message.Guideline.phase140') },
      ];
    },

    defaultFields() {
      return {
        unique_id: {
          label: this.$t('message.Guideline.uniqueId'),
          sortable: true
        },
        name: {
          label: this.$t('message.Guideline.name'),
          sortable: true
        },
        my_role: {},
        phase: {
          label: this.$t('message.Guideline.phase'),
          sortable: true
        },
        deadline: {
          label: this.$t('message.Guideline.deadline'),
          sortable: true
        },
        showDetails: {
          label: this.$t('message.showDetails')
        },
        actions : {
          sortable: false
        },
      }
    },
  },
  mounted () {
    this.phaseFilter = JSON.parse(JSON.stringify(this.getPhaseFilter));
    // console.log(this.phaseFilter);
    this.getData();
  },
  methods: {
    welcomeDialogOff() {
      this.$store.dispatch(SHOW_WELCOME_DIALOG, false);
    },

    getGpcReviewLabel() {
      if (this.isGpc) {
        return this.$t('message.Guideline.startGPCReview');
      }

      return this.$t('message.Guideline.showGPCFiles');
    },

    getReviewLabel(guideline) {
      if (this.imReviewer(guideline)) {
        return this.$t('message.Guideline.startReview');
      }

      return this.$t('message.Guideline.showFiles');
    },

    // getTextColorClass(phaseValue) {
    //   const darkTextPhases = [46, 50, 60, 70, 80, 90, 100, 102, 104, 110];
    //
    //   return darkTextPhases.includes(phaseValue) ? 'text-dark' : 'text-white';
    // },

    filterSelectAll(selected) {
      if (selected) {
        this.phaseFilter = this.filterOptions.map(e => e.value);
      } else {
        this.phaseFilter = [];
      }
    },

    onWelcomeFilter(elements) {
      this.welcomeDialogOff();

      this.$refs.welcomeDialogRef.hide();

      if (elements) {
        this.phaseFilter = elements;
      } else {
        this.phaseFilter = this.filterOptions.map(e => e.value);
      }

      this.getFiltered();
    },

    linkGen (pageNum) {
      if (this.phase === this.guidelinePhases.rejected) {
        return '/rejected/' + pageNum;
      }

      if (this.phase === this.guidelinePhases.preApproved) {
        return '/pre-approved/' + pageNum;
      }

      return '/guidelines/' + pageNum
    },

    deleteRowConfirm(row) {
      this.$swal({
        title: this.$t("message.areYouSure"),
        html: this.$t("message.Guideline.deleteWarning", {name: row.name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.yesImSure"),
        cancelButtonText: this.$t("message.cancel"),
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row)
        }
      })
    },

    deleteRow(row) {
      this.$store.dispatch(GUIDELINE_DELETE, row).then(() => {
        row._rowVariant="danger";
        row.id=null;
        this.$swal({
          title: this.$t("message.success"),
          html: this.$t("message.Guideline.successfullyDeleted", {name: row.name}),
          type: 'success',
          showCancelButton: true,
        })
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    clearQuery() {
      this.$store.commit(GUIDELINE_SET_QUERY, '');
      this.getData();
    },

    allowEdit(guideline) {
      if (this.isSuperUser) {
        return true;
      }

      if (guideline.phase === this.guidelinePhases.rejected) {
        return false;
      }

      if (this.isCommitteeUser) {
        return (guideline.phase === this.guidelinePhases.draft) ||
          (guideline.phase === this.guidelinePhases.formalCheckApproval);
      }

      return false;
    },


    allowFinalPublication(guideline) {
      return ((guideline.phase === this.guidelinePhases.boardApprovalApproved) && this.imSubmitter(guideline)) ||
        (guideline.phase >= this.guidelinePhases.boardApprovalApproved && this.isSuperUser);
    },

    allowDelete(guideline) {
      if (this.isSuperUser) {
        return true;
      }

      if (guideline.rejected === true) {
        return false;
      }

      if (this.isCommitteeUser) {
        return guideline.phase === this.guidelinePhases.draft;
      }

      return false;
    },

    allowAdd() {
      if (this.isNationalDelegate || this.isGpc) {
        return false;
      }

      return true;
    },

    allowUpload(guideline) {
      if ([this.guidelinePhases.preApproved].indexOf(guideline.phase) !== -1) {
        if (this.getUserData.id === guideline.submitter_id) {
          return true;
        }
      }
    },

    allowFinalOnHoldUpload(guideline) {
      if ([this.guidelinePhases.gpcFinalHold].indexOf(guideline.phase) !== -1 || [this.guidelinePhases.boardApprovalOnHold].indexOf(guideline.phase) !== -1) {
        if (this.getUserData.id === guideline.submitter_id) {
          return true;
        }
      }
    },

    allowUploadCorrectedFiles(guideline) {
      // removed as per 20230127_GLM_V3.0_Testing3.pptx
      return false;
    },

    forwardToCommittee(guideline) {
      return (guideline.phase === this.guidelinePhases.uploadGpcReviewedEnd) && this.isSuperUser;
    },

    forwardToNatDel(guideline) {
      return (guideline.phase === this.guidelinePhases.uploadReviewedEnd) && this.isSuperUser;
    },

    allowParallelDecision(guideline) {
      return (guideline.phase === this.guidelinePhases.parallelReviewEnd) && this.isSuperUser;
    },

    showParallelDecisionNotification(guideline) {
      return (guideline.phase === this.guidelinePhases.parallelReviewEnd) && this.isSuperUser && !guideline.readed;
    },

    allowGpcReview(guideline) {
      if (guideline.phase >= this.guidelinePhases.uploadedForGpcReview && guideline.phase < this.guidelinePhases.uploadedForReview) {
        if(this.isGpc || this.isSuperUser) {
          return true;
        }
        return this.imSubmitter(guideline);
      }
    },

    isParallelPhase(guideline) {
      return [
        this.guidelinePhases.parallelReview,
        this.guidelinePhases.parallelReviewed,
        this.guidelinePhases.parallelReviewEnd,
      ].indexOf(guideline.phase) !== -1;
    },

    allowReview(guideline) {
      if (guideline.phase >= this.guidelinePhases.uploadedForReview) {
        // GPC has read-only oversight of parallel review — no review task there
        // (only the office decides at 56 and the submitter re-uploads at 54).
        if (this.isGpc && this.isParallelPhase(guideline)) {
          return false;
        }
        if(this.isIgo || this.isGpc || this.isSuperUser) {
          return true;
        }
        return this.imSubmitter(guideline) || this.isCommitteeUser;
      }
    },

    allowNdReview(guideline) {
      if (guideline.phase >= this.guidelinePhases.reviewByNationalDelegates ||
          guideline.phase === this.guidelinePhases.parallelReview) {
        // GPC oversight of parallel review is read-only (see allowReview).
        if (this.isGpc && this.isParallelPhase(guideline)) {
          return false;
        }
        if(this.isIgo || this.isGpc || this.isSuperUser) {
          return true;
        }
        return this.imSubmitter(guideline) || this.isNationalDelegate;
      }
    },
    
    allowCoiManagment(guideline) {
      return this.isSuperUser && guideline.phase >= this.guidelinePhases.preApproved;
    },

    // Office uploads a manuscript for the submitter at phase 40 (Writing in
    // process), via the same AdminUpload overlay used at the review phases.
    allowAdminUpload(guideline) {
      return this.isSuperUser && guideline.phase === this.guidelinePhases.preApproved;
    },

    // The list has no single `guideline`, so we pass the full row object (the
    // AdminUpload overlay reads guideline.id from it). isReviewUpload=true hides
    // the increment-version checkbox, which is meaningless before GPC review.
    uploadForUser(guideline, userId, uploadId, isReviewUpload) {
      if (this.isSuperUser) {
        this.adminUpload.guideline = guideline;
        this.adminUpload.userId = userId;
        this.adminUpload.uploadId = uploadId;
        this.adminUpload.isReviewUpload = isReviewUpload;
        this.adminUpload.show = true;
      }
    },

    adminCloseUpload(event) {
      this.adminUpload.show = false;
      // The backend advances phase 40 -> 42 atomically on a successful upload, so
      // here we only refresh the list to reflect the new phase / file version.
      if (event == 'reload') {
        this.getData();
      }
    },

    imSubmitter(guideline) {
      if (guideline) {
        return guideline.submitter_id === this.getUserData.id;
      }
    },

    filterGuidelines() {
      this.phaseFilter = JSON.parse(JSON.stringify(this.getPhaseFilter));
    },

    getAll() {
      this.$store.commit('GUIDELINES_RESET_FILTER');
      this.phaseFilter = this.getPhaseFilter;
      this.getData();
    },

    getFiltered() {
      if (this.$route.params.page > 1) {
        this.$route.params.page = 1;
        this.$router.push('/guidelines');
      }

      return this.getData();
    },

    getFilteredOne(id) {

      this.$refs.welcomeDialogRef.hide();

      if (this.$route.params.page > 1) {
        this.$route.params.page = 1;
        this.$router.push('/guidelines');
      }

      this.phaseFilter = [id];

      return this.getData();
    },

    startBoardProcess(guideline) {
      return this.imSubmitter(guideline) && guideline.phase === this.guidelinePhases.reviewByNationalDelegatesEnd;
    },

    getData() {
      this.$store.dispatch(GUIDELINES_REQUEST, {page: this.$route.params.page?this.$route.params.page:1, phases: this.phaseFilter}).then((response) => {
        this.guidelines = response.data;
      }).catch((error) => {
          this.handleUnauth(error.response.status);
          this.handleForbidden(error.response.status);
      });
    },

    editDeadline(row) {
      this.deadline_edit_id = row.id;
      this.deadline = (this.moment(row.deadline, 'DD-MM-YYYY')).format('MM-DD-YYYY');
    },

    cancelEditDeadline() {
      this.deadline_edit_id = this.deadline = null;
    },

    commitEditDeadline(row) {
      let deadline = (this.moment(this.deadline, 'DD-MM-YYYY')).format('DD-MM-YYYY');
      this.$store.dispatch(GUIDELINE_UPDATE_DEADLINE, {gid: this.deadline_edit_id, deadline: deadline}).then(() => {
        this.$swal({
          title: this.$t("message.success"),
          text: this.$t("message.Guideline.deadlineWasUpdated"),
          type: 'success',
          confirmButtonText: 'OK'
        });

        row.deadline = this.moment(this.deadline).format('DD-MM-YYYY');
        this.deadline_edit_id = this.deadline = null;
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    showFileIcon(item) {
      return item.phase === this.guidelinePhases.boardApproval && this.isIgo ||
          item.phase === this.guidelinePhases.gpcFinalApproval && this.isGpc;
    },

    showViewNotification(guideline) {
      return (this.isGpc || this.isSuperUser || ([this.guidelinePhases.boardApproval].indexOf(guideline.phase) !== -1) && this.isIgo) && !guideline.readed
    },

    showAdditionalWorkNeedNotification(guideline) {
      return ([this.guidelinePhases.formalCheckApproval].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showUploadNotification(guideline) {
      return ([this.guidelinePhases.preApproved].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showDoiNotification(guideline) {
      return ([this.guidelinePhases.preApproved].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showForwardToCommitteeNotification(guideline) {
      return ([this.guidelinePhases.uploadGpcReviewedEnd].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showForwardToNDNotification(guideline) {
      return ([this.guidelinePhases.uploadReviewedEnd].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showGpcReviewNotification(guideline) {
      return ([this.guidelinePhases.uploadedForGpcReview, this.guidelinePhases.uploadGpcReviewed].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showReviewNotification(guideline) {
      return ([this.guidelinePhases.uploadedForReview, this.guidelinePhases.parallelReview, this.guidelinePhases.parallelReviewed, this.guidelinePhases.uploadReviewed].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showNDReviewNotification(guideline) {
      return ([this.guidelinePhases.parallelReview, this.guidelinePhases.reviewByNationalDelegates, this.guidelinePhases.reviewedByNationalDelegates].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showStartBoardProcessNotification(guideline) {
      return ([this.guidelinePhases.reviewByNationalDelegatesEnd].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showFinalPublicationNotification(guideline) {
      return ([this.guidelinePhases.boardApprovalApproved].indexOf(guideline.phase) !== -1) && !guideline.readed
    },

    showFinalHoldNotification(guideline) {
      return ([this.guidelinePhases.gpcFinalHold].indexOf(guideline.phase) !== -1 || [this.guidelinePhases.boardApprovalOnHold].indexOf(guideline.phase) !== -1) && this.imSubmitter
    },

    showEditOnHold(guideline) {
      return ([this.guidelinePhases.boardApprovalOnHold].indexOf(guideline.phase) !== -1) && this.isGpc
    },

    sortTable(a, b, key) {
      if (key === 'deadline') {
        const first = this.moment(a[key], 'DD-MM-YYYY').format('X');
        const second = this.moment(b[key], 'DD-MM-YYYY').format('X');

        return first < second ? -1 : (first > second ? 1 : 0)
      }
    },
  },
  watch: {
    // whenever question changes, this function will run
    '$route.params.page': function (newPage) {
      this.$store.dispatch(GUIDELINES_REQUEST, {page: newPage, phases: this.phaseFilter})
        .then((response) => {
          this.guidelines = response.data;
        });
    },
  },
}
</script>

<style scoped lang="scss">
.guidelines-list-content {
  display: flex;
}

.guidelines-list-table {
  background-color: #ffffff ;
}
.guidelines-list {

}

.guidelines-list-filter {
  max-width: 280px;
  background-color: #ffffff;
  margin-left: 15px;
  padding-bottom: 10px;
}

.welcome-section-title {
  margin: 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(100, 100, 100, 0.2);
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.9rem;
  font-weight: bold;
}

.welcome-section-box {
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.lh-12{
  line-height: 1.2em;
}


.notification{
  color: #ed472a;
  position: absolute;
  top: -5px;
  font-size: 1.3em;
}

/* Fixed width for phase badges */
.phase-width {
  width: 200px;
}
</style>
